module.exports = __webpack_public_path__ + "media/success2.9623ac57.wav";